import { css } from 'styled-components'
import { SolidSlimBorder } from './borders'
import { AspiraBold } from './fonts'
import { Refocus } from './resets'
import { values } from './spacing'
import { BodyLarge } from './typography'

export const MenuBoxPaint = css`
  border-color: ${({ theme }) => theme.Colors.forInterface.interfaceColor13};
  background-color: ${({ theme }) => theme.Colors.forInterface.interfaceColor11};
`

export const MenuBox = css`
  ${MenuBoxPaint};
  ${SolidSlimBorder};
`

export const MenuBoxShape = css`
  border-radius: 8px;
  padding: ${values.xxsmall} ${values.xsmall};
`

export const Menu = css`
  ${MenuBox};
  ${MenuBoxShape};
  box-shadow: 0 7px 15px 0 rgba(118, 118, 118, 0.4);
`

export const MenuItemHighlight = css`
  background-color: ${({ theme }) => theme.Colors.forInterface.interfaceColor12};
`

export const MenuItem = css`
  ${BodyLarge};
  padding: ${values.xxsmall};

  &[data-selected] {
    ${AspiraBold};
    ${MenuItemHighlight};
  }

  &:hover {
    ${MenuItemHighlight};
  }
  &:focus-within {
    ${MenuItemHighlight};
    ${Refocus};
  }
`
